export default "__VITE_ASSET__ByK7IbcU__"